import { Modal } from "@4uhub/lib4uhub";
import { InfoOutlined } from "@mui/icons-material";
import { Divider, IconButton, Stack, useTheme } from "@mui/material";
import React, { useState } from "react";

interface IInfoButton {
  title: string;
  content: JSX.Element;
}

export const InfoButton: React.FC<IInfoButton> = ({ title, content }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const theme = useTheme();

  const handleOpen = () => setModalVisible(true);
  const handleClose = () => setModalVisible(false);

  return (
    <>
      <IconButton onClick={handleOpen} sx={{ padding: theme.spacing(1) }}>
        <InfoOutlined fontSize="large" color="info" />
      </IconButton>

      <Modal
        open={modalVisible}
        onClose={handleClose}
        aria-labelledby="info-modal-title"
        aria-describedby="info-modal-description"
        title={title}
      >
        <Stack spacing={2}>
          <Divider />
          {content}
        </Stack>
      </Modal>
    </>
  );
};
